import {
  getActivityLimits,
  removeActivityLimit,
  setActivityLimitFilters,
  updateActivityLimit,
} from '@state/reducers/activityLimitReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { ActivityLimitDto } from '@services/dtos'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import ActivityLimitForm from '../forms/ActivityLimitForm'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { Site } from '@services/api'

export default function ActivityLimitsTable() {
  const dispatch = useAppDispatch()
  const { filters, user } = useAppSelector(({ auth, activityLimit }) => ({
    filters: activityLimit.filters,
    user: auth.user,
  }))

  useEffect(() => {
    return () => {
      dispatch(setActivityLimitFilters({ includeInactive: false }))
    }
  }, [])

  const sites = useMemo(() => {
    const _sites = (user as any & { sites: Site[] })?.sites
    if (_sites?.length === 1) {
      dispatch(setActivityLimitFilters({ siteId: _sites[0].id }))
    }
    return _sites
  }, [user])
  const onSiteChange = (ev: SelectChangeEvent<string>) => {
    const siteId = ev.target.value
    dispatch(setActivityLimitFilters({ siteId: +siteId }))
    dispatch(getActivityLimits())
  }

  const columns: GridColumns<ActivityLimitDto> = useMemo(
    () => [
      {
        field: 'isotope',
        headerName: 'Isotope',
        valueGetter: (params) => params.row.isotope?.name || '',
        width: 150,
      },
      {
        field: 'site',
        headerName: 'Site',
        valueGetter: (params) => params.row.site?.label || '',
        width: 150,
      },
      { field: 'maxActivityMbq', headerName: 'Activité max (MBq)', width: 150 },
      {
        field: 'authorizationNumber',
        headerName: 'N° autorisation',
        width: 150,
      },
      { field: 'notes', headerName: 'Notes', width: 250 },
    ],
    [],
  )

  return (
    <BaseConfigTable<ActivityLimitDto>
      toolbarExtras={
        <FormControl size="small">
          <InputLabel>Site</InputLabel>
          <Select
            value={filters.siteId?.toString()}
            onChange={onSiteChange}
            style={{
              minWidth: '200px',
              marginRight: 6,
            }}
            size="small"
          >
            {sites?.length > 1 && (
              <MenuItem value="">
                <em>Tous</em>
              </MenuItem>
            )}
            {sites?.map((site: Site) => (
              <MenuItem key={site.id} value={site.id}>
                {site.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      }
      columns={columns}
      selectRows={(state) => state.activityLimit.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setActivityLimitFilters({ includeInactive: true }))
        return dispatch(getActivityLimits())
      }}
      deleteThunk={removeActivityLimit}
      toggleThunk={(id, isActive) =>
        updateActivityLimit({ id, dto: { isActive } })
      }
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setActivityLimitFilters({ page }))
        dispatch(getActivityLimits())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <ActivityLimitForm
          editingActivityLimit={editingItem}
          onClose={onClose}
        />
      )}
      resourceLabel="limite d'activité"
      resourcePrefix="la "
    />
  )
}
